import { useCampaignCapabilitiesStore } from '@discovr/features';

/**
 * CampaignReportingTab — thin shell that delegates to the app-provided
 * reporting render prop.
 *
 * The full reporting surface (stats, charts, creator metrics, live analytics)
 * is entirely app-specific and registered by the admin / brand page via
 * useCampaignCapabilitiesStore.setCapabilities({ renderReportingTab }).
 *
 * This component owns nothing except the fallback empty state — all data
 * and behaviour live in the app-provided closure.
 */
export function CampaignReportingTab() {
  const { renderReportingTab } = useCampaignCapabilitiesStore();

  if (!renderReportingTab) {
    return (
      <div className="rounded-2xl border border-dashed border-border bg-muted p-10 text-center">
        <p className="text-body-sm-semibold text-muted-foreground">Reporting overview not available.</p>
      </div>
    );
  }

  return (
    <div className="w-full max-w-full overflow-x-auto pb-10">
      {renderReportingTab()}
    </div>
  );
}
